import { apiClient } from './api'
import { getReceiptImageCompressionSettings as getLocalReceiptImageCompressionSettings } from '../utils/receiptImageCompression'

function toPositiveInt(value, fallback) {
  const parsed = Number(value)
  return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : fallback
}

export async function getReceiptImageCompressionSettings() {
  try {
    const response = await apiClient.get('/public/receipt-image-config')
    const payload = response.data?.data ?? response.data ?? {}
    const defaults = getLocalReceiptImageCompressionSettings()
    return {
      maxDimension: toPositiveInt(payload.maxDimension ?? payload.max_dimension, defaults.maxDimension),
      targetBytes: toPositiveInt(payload.maxPayloadBytes ?? payload.max_payload_bytes, defaults.targetBytes),
      qualitySteps: defaults.qualitySteps,
      dimensionSteps: defaults.dimensionSteps,
    }
  } catch {
    return getLocalReceiptImageCompressionSettings()
  }
}
